module.exports = __webpack_public_path__ + "static/img/bcg.18a674dd.webp";